import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchGrouptripsDtlbannersec } from "../services/GrouptripsDtlbannersec";

const GrouptripsDtlcoverdside = () => {
  const { id } = useParams();
  const [GrouptripsDtl, setGrouptripsDtl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchGrouptripsDtlbannersec(decodeURIComponent(id));

      if (res?.status && res?.data?.length > 0) {
        setGrouptripsDtl(res.data[0]);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!GrouptripsDtl) return <div>No data found</div>;

  // Split covered_place into array of destinations
  const destinations = GrouptripsDtl.covered_place
    ? GrouptripsDtl.covered_place
        .split(",")
        .map((place) => place.trim())
        .filter(Boolean)
    : [];

  return (
    <div className="hidden md:block md:col-span-1">
      <div className="sticky top-4">
        <div className="rounded-lg border bg-card text-card-foreground border-slate-200 shadow-lg">
          <div className="p-4 md:p-6">
            <div className="mb-4 md:mb-6">
              <div className="flex items-baseline gap-2">
                <span className="text-2xl md:text-3xl font-bold text-slate-800">
                  ₹ {GrouptripsDtl.charges}
                </span>
                <span className="text-sm md:text-base text-slate-500 line-through">
                  ₹ {GrouptripsDtl.difficulties}
                </span>
              </div>
              <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent mt-2 bg-teal-50 text-teal-700 hover:bg-teal-50 text-xs md:text-sm">
                Save ₹{GrouptripsDtl.difficulties - GrouptripsDtl.charges}!
              </div>
            </div>
            <div className="space-y-3 md:space-4 mb-4 md:mb-6">
              <div className="flex items-center justify-between py-2 md:py-3 border-b border-slate-100">
                <span className="text-xs md:text-sm text-slate-600">
                  Duration
                </span>
                <span className="text-xs md:text-sm font-semibold text-slate-800">
                  {GrouptripsDtl.duration} / {GrouptripsDtl.no_of_days} days
                </span>
              </div>
              {/*<div className="flex items-center justify-between py-2 md:py-3 border-b border-slate-100">
                <span className="text-xs md:text-sm text-slate-600">
                  Spots Left
                </span>
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 bg-teal-50 text-teal-700 text-xs md:text-sm">
                  Only 3 left!
                </div>
              </div>*/}
              <div className="py-2 md:py-3 border-b border-slate-100">
                <span className="text-xs md:text-sm text-slate-600 block mb-2">
                  Available Dates
                </span>
                <div className="flex flex-wrap gap-1.5 md:gap-2">
                 {(() => {
                let tourDates = [];

                try {
                  tourDates = GrouptripsDtl?.tour_date
                    ? JSON.parse(GrouptripsDtl.tour_date)
                    : [];
                } catch (e) {
                  tourDates = [];
                }

                return (
                  <>
                    {tourDates.map((date, index) => {
                      // Remove weekday (Tuesday / Friday)
                      const cleanDate = date.split("-")[0].trim();

                    return (
                      <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-foreground text-[10px] md:text-xs">
                        {cleanDate}
                      </div>
                    );
                })}
                  </>
                );
              })()}
                </div>
              </div>
            </div>
            <div className="space-y-3">
              <a target="_blank" href="https://wa.me/918920866123" className="inline-flex items-center justify-center whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 px-4 py-2 w-full bg-primary text-white hover:bg-primary/90 h-11 text-base font-semibold rounded-full shadow-lg hover:shadow-xl transition-all">
                Book Now
              </a>
            </div>
            <p className="mt-4 text-[10px] md:text-xs text-slate-500 text-center leading-relaxed">
              Best price guaranteed. Book now to secure your spot!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrouptripsDtlcoverdside;
